export const ITEM_DELETED_MESSAGE = 'This item has been deleted.';
export const BIDDING_HISTORY_TITLE = 'Bidding History';
export const TOP_BID_INDEX = 0;
export const TOP_BID_INITIAL_VALUE = 0;
export const PAGE_TOP_CONTAINER_SPACING = '2rem';
export const RESET_COUNTDOWN_DATE = '0000:00:00';
